import { createContext, useContext } from 'react'
import type { DeleteSearchItem } from '../api/deletes'
import type { EntityDef } from '../api/types'

/** Which of the two step-2 tabs the user is working in. */
export type DeleteSource = 'filter' | 'refs'

export const DATE_RANGES = [
  'Last 30 Days',
  'Last 90 Days',
  'This month',
  'Last month',
  'This fiscal year',
  'Custom',
]

export interface DeleteDraft {
  entityType: string
  entity: EntityDef | null
  source: DeleteSource
  dateRange: string
  from: string
  to: string
  amountMin: string
  amountMax: string
  /** Raw textarea contents of the paste-references tab. */
  refs: string
}

export interface DeleteWizard extends DeleteDraft {
  entities: EntityDef[]
  /** Reference numbers parsed out of `refs`, one per non-empty line. */
  refList: string[]
  /** Real QuickBooks records returned by `POST /delete/search`, null until a search runs. */
  review: DeleteSearchItem[] | null
  /** The template's column labels matching Export, carried from the search response. */
  exportColumns: string[] | null
  setReview: (items: DeleteSearchItem[] | null) => void
  setExportColumns: (columns: string[] | null) => void
  setEntityType: (name: string) => void
  setSource: (source: DeleteSource) => void
  setDateRange: (value: string) => void
  setFrom: (value: string) => void
  setTo: (value: string) => void
  setAmountMin: (value: string) => void
  setAmountMax: (value: string) => void
  setRefs: (value: string) => void
  reset: () => void
}

export const DeleteWizardContext = createContext<DeleteWizard | null>(null)

export function useDeleteWizard(): DeleteWizard {
  const context = useContext(DeleteWizardContext)
  if (!context) throw new Error('useDeleteWizard must be used inside the delete route')
  return context
}
